import React from "react";

export default function AdminHome() {
  return <div>Admin sahifaga xush kelibsiz!</div>;
}
